<div class="recurly-control-wrapper" [class.recurly-control-error]="hasError">
  <div class="recurly-control-container" #container></div>
  <!-- <clr-icon aria-hidden="true" class="clr-validate-icon" shape="exclamation-circle" role="none"></clr-icon> -->
</div>
